export enum Actions {
  SET_ERRORS = '@ERROR/SET_ERRORS'
}
